var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("li", {
    class: { done: _vm.isDone },
    domProps: { innerHTML: _vm._s(_vm.instruction) },
    on: { click: _vm.toggleDone },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }